import { render, staticRenderFns } from "./Static.vue?vue&type=template&id=9add6340&scoped=true&"
import script from "./Static.vue?vue&type=script&lang=js&"
export * from "./Static.vue?vue&type=script&lang=js&"
import style0 from "./Static.vue?vue&type=style&index=0&id=9add6340&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9add6340",
  null
  
)

export default component.exports